import { motion } from "framer-motion";
import { ArrowRight, Radar } from "lucide-react";
import { Reveal } from "./Reveal";
import { fadeUp, viewport, EASE } from "@/lib/motion";

export const FinalCTA = () => {
  return (
    <section id="final-cta" className="relative py-24 md:py-32 bg-white overflow-hidden" data-testid="section-final-cta">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="relative rounded-[2.5rem] border border-slate-100 bg-canvas-soft overflow-hidden px-8 py-16 md:px-16 md:py-24 text-center">
          <div className="pointer-events-none absolute inset-0 -z-0">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 h-[360px] w-[720px] rounded-full bg-brand/10 blur-[120px]" />
            <div className="absolute inset-0 grid-bg opacity-60" />
          </div>

          <div className="relative z-10 max-w-3xl mx-auto">
            <motion.span initial={{ scale: 0, opacity: 0 }} whileInView={{ scale: 1, opacity: 1 }} viewport={viewport} transition={{ duration: 0.6, ease: EASE }}
              className="mx-auto grid place-items-center h-14 w-14 rounded-2xl bg-navy text-white shadow-float">
              <Radar className="h-6 w-6" strokeWidth={1.75} />
            </motion.span>

            <Reveal delay={0.05}>
              <h2 className="mt-8 font-heading text-4xl md:text-6xl font-bold text-navy tracking-tighter leading-[1.05] text-balance">Stay ahead of every exception.</h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 max-w-2xl mx-auto text-lg text-ink-500 leading-relaxed">
                Monitor critical operational issues, prioritize what matters and resolve problems faster with Exception Hub™.
              </p>
            </Reveal>

            <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} transition={{ delay: 0.15 }}
              className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
              <a href="#top" data-testid="final-primary-cta" className="group inline-flex items-center gap-2 h-12 px-7 rounded-full bg-navy text-white font-medium hover:bg-navy-soft transition-colors shadow-float">
                Explore Exception Hub™
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" strokeWidth={2} />
              </a>
              <a href="#top" data-testid="final-secondary-cta" className="inline-flex items-center gap-2 h-12 px-7 rounded-full bg-white text-navy font-medium border border-slate-200 hover:border-slate-300 transition-colors">
                Create Your Free Workspace
              </a>
            </motion.div>

            <Reveal delay={0.2}>
              <div className="mt-10 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 text-sm font-medium text-ink-400">
                <span>One Workspace.</span><span className="text-brand-connector">•</span>
                <span>Complete Visibility.</span><span className="text-brand-connector">•</span>
                <span>Proactive Operations.</span>
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
};
